let preZero = val => {
    return val < 10 ? `0${val}` : val;
};

let getDateStr = date => {
    let res = {};
    res.Year = date.getFullYear();
    res.Month = preZero(date.getMonth() + 1);
    res.Day = preZero(date.getDate());
    res.Hour = preZero(date.getHours());
    res.Minutes = preZero(date.getMinutes());
    res.Seconds = preZero(date.getSeconds());
    return res;
};

let sortParam = obj => {
    let newObj = {};
    if (obj) {
        let newKeys = Object.keys(obj).sort();
        for (let i=0; i<newKeys.length; i++) {
            if (obj[newKeys[i]] || obj[newKeys[i]] === 0) {
                newObj[newKeys[i]] = obj[newKeys[i]];
            }
        }
    } else {
        newObj = obj;
    }
    return newObj;
};

let findObjByKey = (arr, key, val) => {
    let tmp = null;
    for (let item of arr) {
        if (item[key] == val) {
            tmp = item;
        }
    }
    return tmp;
};

let isArray = obj => {
    return Object.prototype.toString.call(obj) == '[object Array]';
};
let Util = {
    /** 把为空的数据添加默认展示内容 */
    setStr(obj) {
        let data = obj;

        if(data instanceof Array) {
            // console.log(11111111);
            // console.log(data);
            for(let i=0; i<data.length; i++) {
                for(let j in data[i]) {
                    if(data[i][j] === ''||data[i][j] === null ||data[i][j] === 'NaN.NaN.NaN') {
                        data[i][j]='--';
                    }
                }
            }
        }else{
            if(data === null) {
                data = '--';
            }else{
                for(let i in data) {
                    if(data[i] === ''||data[i] === null||data[i] === 'NaN.NaN.NaN')
                        data[i] = '--';
                }
            }
        }
        return data;
    },
    /** 把为空的链接添加默认展示 */
    setVal(src, type) {
        let val = src;

        if(val === '--') {
            if(type === 'str') {
                val = 'https://innovationtest.huicye.com/defaultLogo.png';
            } else if (type === 'arr') {
                val = ['https://innovationtest.huicye.com/defaultLogo.png'];
            }else if(type ==='') {
                val = '人民币';
            }else{
                val='--';
            }
        }
        return val;
    },
    /** 把时间戳转为为普通日期格式 */
    getFormatTime(stamp, separator, type) {
        if (stamp === '--') {
            return stamp;
        }
        let date, month, day, hour, minutes, seconds;

        if((stamp+'').length===10) {
            date = new Date(parseInt(stamp) * 1000);
        }else{
            date = new Date(parseInt(stamp));
        }
        if((date.getMonth()+1)<10) {
            month = '0'+(date.getMonth()+1);
        }else{
            month = date.getMonth()+1;
        }

        if(date.getDate()<10) {
            day = '0'+date.getDate();
        }else{
            day = date.getDate();
        }

        if(date.getHours()<10) {
            hour = '0'+date.getHours();
        }else{
            hour = date.getHours();
        }

        if(date.getMinutes()<10) {
            minutes = '0'+date.getMinutes();
        }else{
            minutes = date.getMinutes();
        }

        if(date.getSeconds()<10) {
            seconds = '0'+date.getSeconds();
        }else{
            seconds = date.getSeconds();
        }

        if(type==='date') {
            /** 2019/12/23 */
            return (date.getFullYear()+separator+month
            +separator+day);
        }else if(type==='minute') {
            /** 2019/12/23 10:20*/
            return (date.getFullYear()+separator+month
            +separator+day+' '+hour+':'+minutes);
        }else{
            /** 2019/12/23 10:20:40*/
            return (date.getFullYear()+separator+month
            +separator+day+' '+hour+':'+minutes+
            ':'+seconds);
        }
    },
    toVouchers(toUrl, dymicHost, _this, type=1) {
        if(type&&localStorage.getItem('privileges').indexOf('0108')<0) {
            _this.$message.error('暂无权限');
            return;
        }
        let params = `?parkId=${localStorage.getItem('GLOBAL_PARK_ID')}&ACCESSTOKEN=${localStorage.getItem('X_TOKEN')}wj&REFRESHTOKEN=${localStorage.getItem('REFRESH_TOKEN')}wj&USERNAME=${localStorage.getItem('GLOBAL_USER_NAME')}&AVATAR=${localStorage.getItem('GLOBAL_AVATAR')}&HOSTKEY=${localStorage.getItem('HOSTKEY')}`;

        let url = dymicHost.voucherUrl+toUrl+params;
        window.open(url);
    }
};


export {preZero, getDateStr, sortParam, findObjByKey, isArray, Util};



// WEBPACK FOOTER //
// ./src/util/tools/base.js